module.exports = __webpack_public_path__ + "img/backgroundBi.ca577d2b.png";